import React from 'react';

const GetTimeDifference = ({ date }) => {
    // Convert the responded date string to a Date object
    const respondedOnDate = new Date(date);
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const diffInMs = currentDate - respondedOnDate;

    // Convert milliseconds to seconds, minutes, hours, days
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    // Format the difference
    let timeDifference = '';
    if (diffInDays > 0) {
        timeDifference = `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    } else if (diffInHours > 0) {
        timeDifference = `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    } else if (diffInMinutes > 0) {
        timeDifference = `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
    } else {
        timeDifference = `${diffInSeconds} second${diffInSeconds > 1 ? 's' : ''} ago`;
    }

    return <>{timeDifference}</>;
};

export default GetTimeDifference;
